import { pageNotFoundImg } from "assets/images";
import React from "react";
import "./NotFound.scss";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
const NotFound = () => {
  const { t } = useTranslation();
  return (
    <div className="pageNotFound">
      <div className="container">
        <div className="content">
          <h4>{t(`NOT_FOUND.404`)}</h4>
          <p>{t(`NOT_FOUND.pageNotFound`)}</p>
        </div>
        {/* <div className="image">
        <img src={pageNotFoundImg} alt="" />
      </div> */}
        <div className="button_wrap">
          <Link to="/" className="button">
            {t(`NOT_FOUND.backToHome`)}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
